import React from 'react';


import * as Styled from './shop-one-line-banner.styled.ts';

type OwnProps = {
	text: string;
	image: string;
	colorStart: string;
	colorEnd: string;
}

const ShopOneLineBanner: React.FC<OwnProps> = ({text, image, colorEnd, colorStart}) => {

  return (
    <Styled.Wrapper $colorStart={colorStart} $colorEnd={colorEnd}>
      <Styled.Info>
        <Styled.Title>
					{text}
        </Styled.Title>
				<Styled.Image src={image} />
      </Styled.Info>
    </Styled.Wrapper>
  )
}

export default ShopOneLineBanner;
